import React, { useState, useEffect } from 'react'
import { Row, Col, Container, Form, Button, Modal, Badge, InputGroup } from 'react-bootstrap'
import Card from '../../../components/Card'
import { useNavigate } from 'react-router-dom'
import { apiHandler } from '../../../api/apihandler';
import { TEACHERS_ACTIVITY_LIST_API, TEACHERS_RESULTS_LIST_API, TEACHERS_RESULTS_LIST_DELETE_API, TEACHERS_RESULTS_LIST_PRINT_API } from "../../../api/constants";
import Moment from 'moment';
import loader from '../../../assets/images/page-img/page-load-loader.gif'
import NoDataFound from '../../../components/noDataFound';
import Swal from 'sweetalert2'

// Sample student data - replace with API call
const SAMPLE_STUDENTS = [
    {
        id: 1,
        name: 'Alice Johnson',
        rollNumber: 'ST001',
        avatar: 'https://images.unsplash.com/photo-1494790108755-2616b6b5aa40?w=150',
        attendance: 'present', // present, absent, late
    },
    {
        id: 2,
        name: 'Bob Smith',
        rollNumber: 'ST002',
        avatar: 'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=150',
        attendance: 'present',
    },
    {
        id: 3,
        name: 'Carol Davis',
        rollNumber: 'ST003',
        avatar: 'https://images.unsplash.com/photo-1438761681033-6461ffad8d80?w=150',
        attendance: 'absent',
    },
    {
        id: 4,
        name: 'David Wilson',
        rollNumber: 'ST004',
        avatar: 'https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?w=150',
        attendance: 'late',
    },
    {
        id: 5,
        name: 'Eva Brown',
        rollNumber: 'ST005',
        avatar: 'https://images.unsplash.com/photo-1544725176-7c40e5a71c5e?w=150',
        attendance: 'present',
    },
    {
        id: 6,
        name: 'Frank Miller',
        rollNumber: 'ST006',
        avatar: 'https://images.unsplash.com/photo-1500648767791-00dcc994a43e?w=150',
        attendance: 'present',
    },
];

const AttendancePage = () => {
    const navigate = useNavigate();
    const [students, setStudents] = useState(SAMPLE_STUDENTS);
    const [searchQuery, setSearchQuery] = useState('');
    const [selectedDate, setSelectedDate] = useState(new Date());
    const [showBulkModal, setShowBulkModal] = useState(false);
    const [loading, setLoading] = useState(false);
    const [refreshing, setRefreshing] = useState(false);

    useEffect(() => {
        window.scrollTo({ top: 0, behavior: "smooth" });
        loadAttendanceData();
    }, [selectedDate]);

    const loadAttendanceData = async () => {
        setLoading(true);
        try {
            // Replace with actual API call
            // const response = await apiHandler('GET_ATTENDANCE', 'POST', { date: selectedDate.toISOString().split('T')[0] });
            setTimeout(() => {
                setLoading(false);
            }, 1000);
        } catch (error) {
            console.error('Error loading attendance:', error);
            setLoading(false);
        }
    };

    const formatDate = (date) => {
        return date.toLocaleDateString('en-US', {
            weekday: 'short',
            year: 'numeric',
            month: 'short',
            day: 'numeric'
        });
    };

    const updateAttendance = (studentId, status) => {
        setStudents(prevStudents =>
            prevStudents.map(student =>
                student.id === studentId
                    ? { ...student, attendance: status }
                    : student
            )
        );
    };

    const bulkUpdateAttendance = (status) => {
        setStudents(prevStudents =>
            prevStudents.map(student => ({ ...student, attendance: status }))
        );
        setShowBulkModal(false);
    };

    const saveAttendance = async () => {
        try {
            setLoading(true);
            // Replace with actual API call
            // await apiHandler('SAVE_ATTENDANCE', 'POST', { date: selectedDate.toISOString().split('T')[0], students });
            
            Swal.fire({
                title: 'Success!',
                text: 'Attendance saved successfully!',
                icon: 'success',
                confirmButtonText: 'OK',
                confirmButtonColor: '#3498DB'
            });
            setLoading(false);
        } catch (error) {
            console.error('Error saving attendance:', error);
            Swal.fire({
                title: 'Error!',
                text: 'Failed to save attendance',
                icon: 'error',
                confirmButtonText: 'OK',
                confirmButtonColor: '#E74C3C'
            });
            setLoading(false);
        }
    };

    const filteredStudents = students.filter(student =>
        student.name.toLowerCase().includes(searchQuery.toLowerCase()) ||
        student.rollNumber.toLowerCase().includes(searchQuery.toLowerCase())
    );

    const getAttendanceStats = () => {
        const present = students.filter(s => s.attendance === 'present').length;
        const absent = students.filter(s => s.attendance === 'absent').length;
        const late = students.filter(s => s.attendance === 'late').length;
        const total = students.length;
        return { present, absent, late, total };
    };

    const stats = getAttendanceStats();

    const renderDateSelector = () => (
        <Card className="mb-0" style={{
            borderRadius: '0',
            border: 'none',
            boxShadow: '0 1px 2px rgba(0, 0, 0, 0.1)',
            background: '#ffffff'
        }}>
            <Card.Body style={{ padding: '20px' }}>
                <h4 style={{
                    flex: 1,
                    textAlign: 'center',
                    margin: '26px 16px',
                    fontSize: '18px',
                    fontWeight: '600',
                    color: '#212529'
                }}>
                    Student Attendance
                </h4>
                <h5 style={{ 
                    fontWeight: '600', 
                    fontSize: '16px', 
                    marginBottom: '16px',
                    color: '#212529'
                }}>
                    Select Date
                </h5>
                <div 
                    style={{
                        display: 'flex',
                        alignItems: 'center',
                        background: '#3498DB10',
                        padding: '12px 16px',
                        borderRadius: '8px',
                        border: '1px solid #3498DB30',
                        cursor: 'pointer'
                    }}
                    onClick={() => document.getElementById('dateInput').showPicker()}
                >
                    <i className="material-symbols-outlined" style={{
                        fontSize: '20px',
                        color: '#3498DB',
                        marginRight: '12px'
                    }}>
                        calendar_today
                    </i>
                    <span style={{
                        flex: 1,
                        fontSize: '14px',
                        fontWeight: '600',
                        color: '#212529'
                    }}>
                        {formatDate(selectedDate)}
                    </span>
                    <i className="material-symbols-outlined" style={{
                        fontSize: '20px',
                        color: '#6c757d'
                    }}>
                        keyboard_arrow_down
                    </i>
                    <input
                        id="dateInput"
                        type="date"
                        value={selectedDate.toISOString().split('T')[0]}
                        onChange={(e) => setSelectedDate(new Date(e.target.value))}
                        max={new Date().toISOString().split('T')[0]}
                        style={{
                            position: 'absolute',
                            opacity: 0,
                            pointerEvents: 'none'
                        }}
                    />
                </div>
            </Card.Body>
        </Card>
    );

    const renderStatsCards = () => (
        <Card className="mb-0" style={{
            borderRadius: '0',
            border: 'none',
            background: '#ffffff'
        }}>
            <Card.Body style={{ padding: '20px' }}>
                <Row style={{ gap: '12px', margin: '0' }}>
                    <Col style={{
                        background: 'rgba(39, 174, 96, 0.08)',
                        borderRadius: '16px',
                        padding: '16px',
                        textAlign: 'center',
                        border: '0.5px solid rgba(0, 0, 0, 0.05)'
                    }}>
                        <div style={{
                            width: '40px',
                            height: '40px',
                            borderRadius: '20px',
                            background: 'rgba(39, 174, 96, 0.15)',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            margin: '0 auto 8px auto'
                        }}>
                            <i className="material-symbols-outlined" style={{
                                fontSize: '22px',
                                color: '#27AE60'
                            }}>
                                check_circle
                            </i>
                        </div>
                        <div style={{
                            fontSize: '20px',
                            fontWeight: 'bold',
                            color: '#212529',
                            marginTop: '4px',
                            marginBottom: '2px'
                        }}>
                            {stats.present}
                        </div>
                        <div style={{
                            fontSize: '11px',
                            color: '#6c757d',
                            fontWeight: '500',
                            opacity: 0.8
                        }}>
                            Present
                        </div>
                    </Col>
                    <Col style={{
                        background: 'rgba(231, 76, 60, 0.08)',
                        borderRadius: '16px',
                        padding: '16px',
                        textAlign: 'center',
                        border: '0.5px solid rgba(0, 0, 0, 0.05)'
                    }}>
                        <div style={{
                            width: '40px',
                            height: '40px',
                            borderRadius: '20px',
                            background: 'rgba(231, 76, 60, 0.15)',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            margin: '0 auto 8px auto'
                        }}>
                            <i className="material-symbols-outlined" style={{
                                fontSize: '22px',
                                color: '#E74C3C'
                            }}>
                                cancel
                            </i>
                        </div>
                        <div style={{
                            fontSize: '20px',
                            fontWeight: 'bold',
                            color: '#212529',
                            marginTop: '4px',
                            marginBottom: '2px'
                        }}>
                            {stats.absent}
                        </div>
                        <div style={{
                            fontSize: '11px',
                            color: '#6c757d',
                            fontWeight: '500',
                            opacity: 0.8
                        }}>
                            Absent
                        </div>
                    </Col>
                    <Col style={{
                        background: 'rgba(243, 156, 18, 0.08)',
                        borderRadius: '16px',
                        padding: '16px',
                        textAlign: 'center',
                        border: '0.5px solid rgba(0, 0, 0, 0.05)'
                    }}>
                        <div style={{
                            width: '40px',
                            height: '40px',
                            borderRadius: '20px',
                            background: 'rgba(243, 156, 18, 0.15)',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            margin: '0 auto 8px auto'
                        }}>
                            <i className="material-symbols-outlined" style={{
                                fontSize: '22px',
                                color: '#F39C12'
                            }}>
                                schedule
                            </i>
                        </div>
                        <div style={{
                            fontSize: '20px',
                            fontWeight: 'bold',
                            color: '#212529',
                            marginTop: '4px',
                            marginBottom: '2px'
                        }}>
                            {stats.late}
                        </div>
                        <div style={{
                            fontSize: '11px',
                            color: '#6c757d',
                            fontWeight: '500',
                            opacity: 0.8
                        }}>
                            Late
                        </div>
                    </Col>
                    <Col style={{
                        background: 'rgba(52, 152, 219, 0.08)',
                        borderRadius: '16px',
                        padding: '16px',
                        textAlign: 'center',
                        border: '0.5px solid rgba(0, 0, 0, 0.05)'
                    }}>
                        <div style={{
                            width: '40px',
                            height: '40px',
                            borderRadius: '20px',
                            background: 'rgba(52, 152, 219, 0.15)',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            margin: '0 auto 8px auto'
                        }}>
                            <i className="material-symbols-outlined" style={{
                                fontSize: '22px',
                                color: '#3498DB'
                            }}>
                                group
                            </i>
                        </div>
                        <div style={{
                            fontSize: '20px',
                            fontWeight: 'bold',
                            color: '#212529',
                            marginTop: '4px',
                            marginBottom: '2px'
                        }}>
                            {stats.total}
                        </div>
                        <div style={{
                            fontSize: '11px',
                            color: '#6c757d',
                            fontWeight: '500',
                            opacity: 0.8
                        }}>
                            Total
                        </div>
                    </Col>
                </Row>
            </Card.Body>
        </Card>
    );

    const renderSearchBar = () => (
        <div style={{
            background: '#ffffff',
            padding: '20px 20px 12px 20px'
        }}>
            <div style={{
                display: 'flex',
                alignItems: 'center',
                background: '#ffffff',
                padding: '12px 16px',
                borderRadius: '8px',
                border: '1px solid #e9ecef',
                boxShadow: '0 1px 2px rgba(0, 0, 0, 0.1)'
            }}>
                <i className="material-symbols-outlined" style={{
                    fontSize: '20px',
                    color: '#6c757d',
                    marginRight: '12px'
                }}>
                    search
                </i>
                <input
                    type="text"
                    placeholder="Search students by name or roll number..."
                    value={searchQuery}
                    onChange={(e) => setSearchQuery(e.target.value)}
                    style={{
                        flex: 1,
                        border: 'none',
                        outline: 'none',
                        fontSize: '14px',
                        color: '#212529'
                    }}
                />
                {searchQuery && (
                    <button
                        onClick={() => setSearchQuery('')}
                        style={{
                            background: 'transparent',
                            border: 'none',
                            cursor: 'pointer',
                            padding: '4px',
                            marginLeft: '8px'
                        }}
                    >
                        <i className="material-symbols-outlined" style={{
                            fontSize: '20px',
                            color: '#6c757d'
                        }}>
                            clear
                        </i>
                    </button>
                )}
            </div>
        </div>
    );

    const renderBulkActions = () => (
        <div style={{
            background: '#ffffff',
            padding: '8px 20px 20px 20px'
        }}>
            <h5 style={{ 
                fontWeight: '600', 
                fontSize: '16px', 
                marginBottom: '8px',
                color: '#212529'
            }}>
                Quick Actions
            </h5>
            <Row style={{ gap: '10px', margin: '0' }}>
                <Col>
                    <button
                        style={{
                            width: '100%',
                            display: 'flex',
                            flexDirection: 'column',
                            alignItems: 'center',
                            justifyContent: 'center',
                            background: '#27AE60',
                            border: 'none',
                            borderRadius: '12px',
                            padding: '16px 12px',
                            cursor: 'pointer',
                            minHeight: '65px',
                            boxShadow: '0 4px 8px rgba(39, 174, 96, 0.3)'
                        }}
                        onClick={() => bulkUpdateAttendance('present')}
                    >
                        <div style={{
                            width: '28px',
                            height: '28px',
                            borderRadius: '14px',
                            background: 'rgba(255, 255, 255, 0.2)',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            marginBottom: '6px'
                        }}>
                            <i className="material-symbols-outlined" style={{
                                fontSize: '18px',
                                color: '#ffffff'
                            }}>
                                check
                            </i>
                        </div>
                        <span style={{
                            fontSize: '12px',
                            fontWeight: '600',
                            color: '#ffffff',
                            textAlign: 'center'
                        }}>
                            All Present
                        </span>
                    </button>
                </Col>
                <Col>
                    <button
                        style={{
                            width: '100%',
                            display: 'flex',
                            flexDirection: 'column',
                            alignItems: 'center',
                            justifyContent: 'center',
                            background: '#E74C3C',
                            border: 'none',
                            borderRadius: '12px',
                            padding: '16px 12px',
                            cursor: 'pointer',
                            minHeight: '65px',
                            boxShadow: '0 4px 8px rgba(231, 76, 60, 0.3)'
                        }}
                        onClick={() => bulkUpdateAttendance('absent')}
                    >
                        <div style={{
                            width: '28px',
                            height: '28px',
                            borderRadius: '14px',
                            background: 'rgba(255, 255, 255, 0.2)',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            marginBottom: '6px'
                        }}>
                            <i className="material-symbols-outlined" style={{
                                fontSize: '18px',
                                color: '#ffffff'
                            }}>
                                close
                            </i>
                        </div>
                        <span style={{
                            fontSize: '12px',
                            fontWeight: '600',
                            color: '#ffffff',
                            textAlign: 'center'
                        }}>
                            All Absent
                        </span>
                    </button>
                </Col>
                <Col>
                    <button
                        style={{
                            width: '100%',
                            display: 'flex',
                            flexDirection: 'column',
                            alignItems: 'center',
                            justifyContent: 'center',
                            background: '#F39C12',
                            border: 'none',
                            borderRadius: '12px',
                            padding: '16px 12px',
                            cursor: 'pointer',
                            minHeight: '65px',
                            boxShadow: '0 4px 8px rgba(243, 156, 18, 0.3)'
                        }}
                        onClick={() => bulkUpdateAttendance('late')}
                    >
                        <div style={{
                            width: '28px',
                            height: '28px',
                            borderRadius: '14px',
                            background: 'rgba(255, 255, 255, 0.2)',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            marginBottom: '6px'
                        }}>
                            <i className="material-symbols-outlined" style={{
                                fontSize: '18px',
                                color: '#ffffff'
                            }}>
                                schedule
                            </i>
                        </div>
                        <span style={{
                            fontSize: '12px',
                            fontWeight: '600',
                            color: '#ffffff',
                            textAlign: 'center'
                        }}>
                            All Late
                        </span>
                    </button>
                </Col>
            </Row>
        </div>
    );

    const renderStudentItem = (student, index) => (
        <div key={student.id}>
            <div style={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between',
                background: '#ffffff',
                padding: '16px'
            }}>
                <div style={{
                    display: 'flex',
                    alignItems: 'center',
                    flex: 1
                }}>
                    <img
                        src={student.avatar}
                        alt={student.name}
                        style={{
                            width: '45px',
                            height: '45px',
                            borderRadius: '22.5px',
                            marginRight: '12px',
                            objectFit: 'cover'
                        }}
                    />
                    <div style={{ flex: 1 }}>
                        <div style={{
                            fontSize: '14px',
                            fontWeight: '600',
                            color: '#212529',
                            marginBottom: '2px'
                        }}>
                            {student.name}
                        </div>
                        <div style={{
                            fontSize: '12px',
                            color: '#6c757d'
                        }}>
                            Roll: {student.rollNumber}
                        </div>
                    </div>
                </div>
                <div style={{
                    display: 'flex',
                    gap: '8px'
                }}>
                    <button
                        style={{
                            width: '32px',
                            height: '32px',
                            borderRadius: '16px',
                            display: 'flex',
                            justifyContent: 'center',
                            alignItems: 'center',
                            border: student.attendance === 'present' ? 'none' : '1.5px solid #e9ecef',
                            background: student.attendance === 'present' ? '#28a745' : '#ffffff',
                            cursor: 'pointer',
                            transition: 'all 0.2s ease'
                        }}
                        onClick={() => updateAttendance(student.id, 'present')}
                    >
                        <i className="material-symbols-outlined" style={{
                            fontSize: '16px',
                            color: student.attendance === 'present' ? '#ffffff' : '#28a745'
                        }}>
                            check
                        </i>
                    </button>
                    <button
                        style={{
                            width: '32px',
                            height: '32px',
                            borderRadius: '16px',
                            display: 'flex',
                            justifyContent: 'center',
                            alignItems: 'center',
                            border: student.attendance === 'late' ? 'none' : '1.5px solid #e9ecef',
                            background: student.attendance === 'late' ? '#fd7e14' : '#ffffff',
                            cursor: 'pointer',
                            transition: 'all 0.2s ease'
                        }}
                        onClick={() => updateAttendance(student.id, 'late')}
                    >
                        <i className="material-symbols-outlined" style={{
                            fontSize: '16px',
                            color: student.attendance === 'late' ? '#ffffff' : '#fd7e14'
                        }}>
                            schedule
                        </i>
                    </button>
                    <button
                        style={{
                            width: '32px',
                            height: '32px',
                            borderRadius: '16px',
                            display: 'flex',
                            justifyContent: 'center',
                            alignItems: 'center',
                            border: student.attendance === 'absent' ? 'none' : '1.5px solid #e9ecef',
                            background: student.attendance === 'absent' ? '#dc3545' : '#ffffff',
                            cursor: 'pointer',
                            transition: 'all 0.2s ease'
                        }}
                        onClick={() => updateAttendance(student.id, 'absent')}
                    >
                        <i className="material-symbols-outlined" style={{
                            fontSize: '16px',
                            color: student.attendance === 'absent' ? '#ffffff' : '#dc3545'
                        }}>
                            close
                        </i>
                    </button>
                </div>
            </div>
            {index < filteredStudents.length - 1 && (
                <div style={{
                    height: '1px',
                    background: 'rgba(0, 0, 0, 0.06)',
                    margin: '12px 16px'
                }} />
            )}
        </div>
    );

    const renderStudentsList = () => (
        <div style={{
            background: '#ffffff',
            padding: '8px 20px 20px 20px'
        }}>
            <h5 style={{ 
                fontWeight: '600', 
                fontSize: '16px', 
                marginBottom: '16px',
                color: '#212529'
            }}>
                Students ({filteredStudents.length})
            </h5>
            <div>
                {filteredStudents.map((student, index) => renderStudentItem(student, index))}
            </div>
        </div>
    );

    const renderSaveButton = () => (
        <div style={{
            background: '#ffffff',
            padding: '20px'
        }}>
            <button
                onClick={saveAttendance}
                disabled={loading}
                style={{
                    width: '100%',
                    background: '#3498DB',
                    border: 'none',
                    borderRadius: '12px',
                    padding: '16px 20px',
                    fontSize: '16px',
                    fontWeight: '600',
                    color: '#ffffff',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    gap: '8px',
                    cursor: 'pointer',
                    boxShadow: '0 6px 10px rgba(52, 152, 219, 0.4)'
                }}
            >
                {loading ? (
                    <div className="spinner-border spinner-border-sm" role="status">
                        <span className="visually-hidden">Loading...</span>
                    </div>
                ) : (
                    <>
                        <i className="material-symbols-outlined" style={{ fontSize: '20px' }}>
                            save
                        </i>
                        Save Attendance
                    </>
                )}
            </button>
        </div>
    );

    const renderBulkModal = () => (
        <Modal show={showBulkModal} onHide={() => setShowBulkModal(false)} centered>
            <Modal.Body style={{ 
                padding: '20px',
                borderRadius: '16px'
            }}>
                <h5 style={{
                    fontSize: '18px',
                    fontWeight: '600',
                    color: '#212529',
                    textAlign: 'center',
                    marginBottom: '20px'
                }}>
                    Bulk Actions
                </h5>
                <div style={{ display: 'flex', flexDirection: 'column', gap: '0' }}>
                    <button
                        style={{
                            display: 'flex',
                            alignItems: 'center',
                            gap: '12px',
                            padding: '16px',
                            background: 'transparent',
                            border: 'none',
                            borderRadius: '8px',
                            cursor: 'pointer',
                            transition: 'background 0.2s ease',
                            width: '100%'
                        }}
                        onClick={() => {
                            bulkUpdateAttendance('present');
                            setShowBulkModal(false);
                        }}
                        onMouseEnter={(e) => e.target.style.background = '#f8f9fa'}
                        onMouseLeave={(e) => e.target.style.background = 'transparent'}
                    >
                        <i className="material-symbols-outlined" style={{
                            fontSize: '20px',
                            color: '#28a745'
                        }}>
                            check_circle
                        </i>
                        <span style={{
                            fontSize: '14px',
                            color: '#212529',
                            flex: 1,
                            textAlign: 'left'
                        }}>
                            Mark All Present
                        </span>
                    </button>
                    <button
                        style={{
                            display: 'flex',
                            alignItems: 'center',
                            gap: '12px',
                            padding: '16px',
                            background: 'transparent',
                            border: 'none',
                            borderRadius: '8px',
                            cursor: 'pointer',
                            transition: 'background 0.2s ease',
                            width: '100%'
                        }}
                        onClick={() => {
                            bulkUpdateAttendance('absent');
                            setShowBulkModal(false);
                        }}
                        onMouseEnter={(e) => e.target.style.background = '#f8f9fa'}
                        onMouseLeave={(e) => e.target.style.background = 'transparent'}
                    >
                        <i className="material-symbols-outlined" style={{
                            fontSize: '20px',
                            color: '#dc3545'
                        }}>
                            cancel
                        </i>
                        <span style={{
                            fontSize: '14px',
                            color: '#212529',
                            flex: 1,
                            textAlign: 'left'
                        }}>
                            Mark All Absent
                        </span>
                    </button>
                    <button
                        style={{
                            display: 'flex',
                            alignItems: 'center',
                            gap: '12px',
                            padding: '16px',
                            background: 'transparent',
                            border: 'none',
                            borderRadius: '8px',
                            cursor: 'pointer',
                            transition: 'background 0.2s ease',
                            width: '100%'
                        }}
                        onClick={() => {
                            bulkUpdateAttendance('late');
                            setShowBulkModal(false);
                        }}
                        onMouseEnter={(e) => e.target.style.background = '#f8f9fa'}
                        onMouseLeave={(e) => e.target.style.background = 'transparent'}
                    >
                        <i className="material-symbols-outlined" style={{
                            fontSize: '20px',
                            color: '#fd7e14'
                        }}>
                            schedule
                        </i>
                        <span style={{
                            fontSize: '14px',
                            color: '#212529',
                            flex: 1,
                            textAlign: 'left'
                        }}>
                            Mark All Late
                        </span>
                    </button>
                    <hr style={{ margin: '8px 0', borderColor: '#e9ecef' }} />
                    <button
                        style={{
                            display: 'flex',
                            alignItems: 'center',
                            gap: '12px',
                            padding: '16px',
                            background: 'transparent',
                            border: 'none',
                            borderRadius: '8px',
                            cursor: 'pointer',
                            transition: 'background 0.2s ease',
                            width: '100%'
                        }}
                        onClick={() => setShowBulkModal(false)}
                        onMouseEnter={(e) => e.target.style.background = '#f8f9fa'}
                        onMouseLeave={(e) => e.target.style.background = 'transparent'}
                    >
                        <i className="material-symbols-outlined" style={{
                            fontSize: '20px',
                            color: '#6c757d'
                        }}>
                            close
                        </i>
                        <span style={{
                            fontSize: '14px',
                            color: '#212529',
                            flex: 1,
                            textAlign: 'left'
                        }}>
                            Cancel
                        </span>
                    </button>
                </div>
            </Modal.Body>
        </Modal>
    );

    return (
        <>
            <div id='content-page' className='content-page'>
                <Container //fluid style={{ padding: 0 }}
                >
                    <Row>
                        <Col lg={12} className="mx-auto" style={{ padding: 0 }}>
                            {loading ? (
                                <div style={{
                                    display: 'flex',
                                    flexDirection: 'column',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    minHeight: '400px',
                                    background: '#ffffff'
                                }}>
                                    <img src={loader} alt="loader" style={{ height: "100px" }} />
                                    <p style={{
                                        color: '#6c757d',
                                        fontSize: '14px',
                                        marginTop: '16px'
                                    }}>
                                        Loading attendance...
                                    </p>
                                </div>
                            ) : (
                                <>
                                    {renderDateSelector()}
                                    {renderStatsCards()}
                                    {renderSearchBar()}
                                    {renderBulkActions()}
                                    {renderStudentsList()}
                                    {renderSaveButton()}
                                </>
                            )}
                            {renderBulkModal()}
                        </Col>
                    </Row>
                </Container>
            </div>
        </>
    )
}

export default AttendancePage